// src/frontend/components/layout/NavBar.jsx
import React, {useState} from 'react';
import {BsBell, BsMoon, BsSun} from 'react-icons/bs';
import {useNotifications} from '../../context/NotificationContext';
import NotificationCenter from './NotificationCenter';

export default function NavBar({theme, toggleTheme}) {
    const {unreadCount} = useNotifications();
    const [isNotificationOpen, setIsNotificationOpen] = useState(false);

    return (
        <nav
            className="fixed top-0 left-0 right-0 z-50 bg-white/80 dark:bg-black/80 backdrop-blur-xl border-b border-gray-200/50 dark:border-white/10 shadow-sm">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-end items-center h-16 relative">
                    <div className="flex items-center space-x-6">
                        {/* Notifications */}
                        <button
                            aria-label="Notifications"
                            onClick={() => setIsNotificationOpen(!isNotificationOpen)}
                            className="relative p-2 rounded-full hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
                        >
                            <BsBell className="text-xl text-gray-700 dark:text-gray-300"/>
                            {unreadCount > 0 && (
                                <span
                                    className="absolute -top-1 -right-1 bg-red-500 text-white text-xs font-bold rounded-full px-1.5 py-0.5 animate-pulse">
                  {unreadCount}
                </span>
                            )}
                        </button>

                        {/* Theme Toggle */}
                        <button
                            aria-label="Toggle Theme"
                            onClick={toggleTheme}
                            className="p-2 rounded-full hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
                        >
                            {theme === 'light' ? (
                                <BsMoon className="text-xl text-gray-700 dark:text-gray-300"/>
                            ) : (
                                <BsSun className="text-xl text-gray-700 dark:text-gray-300"/>
                            )}
                        </button>
                    </div>

                    {/* Dropdown */}
                    {isNotificationOpen && (
                        <NotificationCenter
                            isOpen={isNotificationOpen}
                            onClose={() => setIsNotificationOpen(false)}
                        />
                    )}
                </div>
            </div>
        </nav>
    );
}